export default "__VITE_ASSET__FWNpJkc0__"